import React from 'react';
import styles from './MainActions.module.scss';
import { useNavigate } from 'react-router-dom';
import { SFButton } from 'sfui';
import { Topic } from '../../../Models';
import { useDesktopQuery } from '../../../Hooks';
import { HtmlContent } from '../../../Components/HtmlContent/HtmlContent';

export interface MainActionsProps {
  title_desktop: string;
  title_mobile: string;
  topics: Topic[];
}

export const MainActions = ({
  title_desktop,
  title_mobile,
  topics
}: MainActionsProps): React.ReactElement<MainActionsProps> => {
  const navigate = useNavigate();
  const isDesktop = useDesktopQuery();

  return (
    <div className={styles.mainActions}>
      <HtmlContent
        className={styles.title}
        content={isDesktop ? title_desktop : title_mobile}
      />

      <div className={styles.actions}>
        {topics.map((topic: Topic) => (
          <SFButton
            key={topic.id}
            size="large"
            onClick={() => navigate(`/topic/${topic.id}`)}
          >
            {topic.name}
          </SFButton>
        ))}
      </div>
    </div>
  );
};
